import { Command } from "cmdk";
import { Button } from "../../button/Button";
import { Divider } from "../../divider/Divider";
import * as selectStyles from "../common/Select.css";

export interface FooterActionsProps {
  /**
   * Disables the Clear button when true
   */
  clearDisabled: boolean;
  /**
   *  Called when the Clear button is clicked
   */
  onClear: () => void;
  /**
   * Called when the Close button is clicked
   */
  onClose: () => void;
}

/**
 * Renders Clear and Close buttons for the Select footer.
 */

export function SelectFooterActions({
  clearDisabled,
  onClear,
  onClose
}: FooterActionsProps): React.ReactElement {
  return (
    <>
      <Divider orientation="horizontal" />
      <Command.Group>
        <div className={selectStyles.selectFooterWrapper}>
          <Command.Item
            onSelect={() => {
              if (!clearDisabled) {
                onClear();
              }
            }}
            className={selectStyles.selectCenterGrow}
            aria-disabled={clearDisabled}
          >
            <Button
              variant="tertiary"
              className={selectStyles.selectButtonLayout}
              disabled={clearDisabled}
              size="sm"
            >
              Clear
            </Button>
          </Command.Item>
          <Divider orientation="vertical" />
          <Command.Item
            onSelect={onClose}
            className={selectStyles.selectCenterInteractive}
          >
            <Button
              variant="tertiary"
              className={selectStyles.selectButtonLayout}
              size="sm"
            >
              Close
            </Button>
          </Command.Item>
        </div>
      </Command.Group>
    </>
  );
}
